export default __webpack_public_path__ + "83561a1a0171a67c1481f7abe81df7fb.png";